// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as $$Array from "../../../../../../../../../../node_modules/rescript/lib/es6/array.js";
import * as Curry from "../../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Js_dict from "../../../../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Timestamp$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as ModificationLegends from "./ModificationLegends.bs.js";
import * as ModificationsContext from "../../../../library/modifications-context/ModificationsContext.bs.js";
import * as ModificationListViewVm from "../../../../vm-mapper/ModificationListViewVm.bs.js";
import * as DragAndDropModification from "./DragAndDropModification.bs.js";
import * as ApproveConfirmationModal from "./ApproveConfirmationModal.bs.js";
import * as ModificationModalManager from "../../../modals/ModificationModalManager.bs.js";
import * as ModificationListViewFooter from "./modification-list-footer/ModificationListViewFooter.bs.js";

function getTitleAndSubtext(t) {
  if (t) {
    return [
            "Take action on all pending modifications",
            "Actions can be submitted only after acting on all pending modifications. When a pending modification is approved, it is accepted with the priority order assigned to it."
          ];
  } else {
    return [
            "Drag the pending modification rows to rearrange the priority order",
            "Submit the new priorities after you're done. The entire modification set along with updated priority order will be sent for approval."
          ];
  }
}

function ModificationListView$HelperText(Props) {
  var is_edited = Props.is_edited;
  var match = is_edited ? [
      "Take action on all pending modifications",
      "Actions can be submitted only after acting on all pending modifications. When a pending modification is approved, it is accepted with the priority order assigned to it."
    ] : [
      "Drag the pending modification rows to rearrange the priority order",
      "Submit the new priorities after you're done. The entire modification set along with updated priority order will be sent for approval."
    ];
  return React.createElement("p", {
              className: "c-modification-helper-text"
            }, React.createElement("b", undefined, match[0]), React.createElement("div", {
                  className: "sub-text"
                }, match[1]));
}

var HelperText = {
  getTitleAndSubtext: getTitleAndSubtext,
  make: ModificationListView$HelperText
};

function isEditModificationSubmitDisabled(modifications, edited_modifications) {
  var edited_external_ids = $$Array.to_list(Object.keys(edited_modifications));
  return List.exists((function (m) {
                return !List.exists((function (e) {
                              return e === m.external_id;
                            }), edited_external_ids);
              }), List.filter(function (m) {
                    return m.status === /* Pending */1;
                  })($$Array.to_list(Js_dict.values(modifications))));
}

function displayPrioritiesByTab(active_tab, modifications_map, displayed_priority) {
  if (active_tab) {
    if (List.exists((function (a) {
              return a.status === /* Pending */1;
            }), $$Array.to_list(Js_dict.values(modifications_map)))) {
      return displayed_priority;
    } else {
      return /* [] */0;
    }
  } else {
    return List.filter(function (external_id) {
                  var modification = modifications_map[external_id];
                  return modification.status !== /* Pending */1;
                })(displayed_priority);
  }
}

function ModificationListView(Props) {
  var active_tab = Props.active_tab;
  var modifications = Props.modifications;
  var core_pricing = Props.core_pricing;
  var dispatch = Props.dispatch;
  var match = ModificationModalManager.useModal(undefined);
  var open_modal = match[1];
  var match$1 = React.useState(function () {
        return [
                false,
                undefined
              ];
      });
  var toggleApproveConfirmation = match$1[1];
  var approve_confirmation = match$1[0];
  var match$2 = ModificationsContext.useContext(undefined);
  var edited_modifications = match$2.edited_modifications;
  var modified_priorities = match$2.modified_priorities;
  var modifications_map = ModificationListViewVm.getVm(core_pricing, modifications, match$2.zones, match$2.clusters);
  var priority_list = displayPrioritiesByTab(active_tab, modifications_map, modified_priorities ? modified_priorities : match$2.initial_priorities);
  var tmp;
  if (approve_confirmation[0]) {
    var match$3 = approve_confirmation[1];
    if (match$3 !== undefined) {
      var cb = match$3[0];
      tmp = React.createElement(ApproveConfirmationModal.make, {
            isOpen: true,
            start_date: match$3[1],
            onConfirmCb: (function (param) {
                Curry._1(toggleApproveConfirmation, (function (param) {
                        return [
                                false,
                                undefined
                              ];
                      }));
                return Curry._1(cb, undefined);
              }),
            onCancelCb: (function (param) {
                return Curry._1(toggleApproveConfirmation, (function (param) {
                              return [
                                      false,
                                      undefined
                                    ];
                            }));
              })
          });
    } else {
      tmp = null;
    }
  } else {
    tmp = null;
  }
  return React.createElement(React.Fragment, undefined, active_tab === /* PendingPriorities */1 ? React.createElement(ModificationListView$HelperText, {
                    is_edited: Object.keys(edited_modifications).length !== 0
                  }) : null, React.createElement(ModificationLegends.make, {}), React.createElement(DragAndDropModification.make, {
                  modifications: modifications_map,
                  priority: priority_list,
                  is_prioritised: List.length(modified_priorities) !== 0,
                  is_core_pricing_pending: core_pricing.status === /* Pending */1,
                  update_priority: (function (priority) {
                      return Curry._1(dispatch, {
                                  TAG: /* SetPriority */3,
                                  _0: priority
                                });
                    }),
                  open_modal: open_modal,
                  take_action_cb: (function (external_id, action_taken) {
                      if (action_taken !== 2) {
                        return Curry._1(dispatch, {
                                    TAG: /* SetEditModification */4,
                                    _0: external_id,
                                    _1: action_taken
                                  });
                      }
                      var start_date = modifications_map[external_id].start_date;
                      if (Timestamp$Catalyst.isAfter(Timestamp$Catalyst.now(undefined), start_date)) {
                        return Curry._1(toggleApproveConfirmation, (function (param) {
                                      return [
                                              true,
                                              [
                                                (function (param) {
                                                    return Curry._1(dispatch, {
                                                                TAG: /* SetEditModification */4,
                                                                _0: external_id,
                                                                _1: action_taken
                                                              });
                                                  }),
                                                start_date
                                              ]
                                            ];
                                    }));
                      } else {
                        return Curry._1(dispatch, {
                                    TAG: /* SetEditModification */4,
                                    _0: external_id,
                                    _1: action_taken
                                  });
                      }
                    })
                }), React.createElement(ModificationListViewFooter.make, {
                  open_create_modification_modal: (function (param) {
                      return Curry._1(open_modal, {
                                  TAG: /* CreateModification */1,
                                  core_pricing: core_pricing
                                });
                    }),
                  reset_list: (function (param) {
                      return Curry._1(dispatch, /* ResetModification */0);
                    }),
                  core_pricing_external_id: core_pricing.campaign_id,
                  is_submit_disabled: isEditModificationSubmitDisabled(modifications_map, edited_modifications)
                }), match[0], tmp);
}

var make = ModificationListView;

export {
  HelperText ,
  isEditModificationSubmitDisabled ,
  displayPrioritiesByTab ,
  make ,
  
}
/* react Not a pure module */
